import { render, staticRenderFns } from "./MChat.vue?vue&type=template&id=c3139c36&scoped=true"
import script from "./MChat.vue?vue&type=script&lang=js"
export * from "./MChat.vue?vue&type=script&lang=js"
import style0 from "./MChat.vue?vue&type=style&index=0&id=c3139c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3139c36",
  null
  
)

export default component.exports